export default __webpack_public_path__ + "static/media/Logo.9ef3e77b.png";